var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPeopleCarry(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.057,
    height: 17.047,
    viewBox: "0 0 21.057 17.047",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-people-carry",
    "data-name": "Icon awesome-people-carry",
    d: "M4,3A1.5,1.5,0,1,0,2.5,1.5,1.5,1.5,0,0,0,4,3ZM16,3a1.5,1.5,0,1,0-1.5-1.5A1.5,1.5,0,0,0,16,3Zm3.928,11.628-1.375-3.437-1.284,1.45-.062.569.866,2.163A1,1,0,0,0,19,16a.972.972,0,0,0,.372-.072A1,1,0,0,0,19.928,14.628ZM18.859,8.072l-.578-2.506a2.025,2.025,0,0,0-1.172-1.4,1.928,1.928,0,0,0-1.753.1,3.424,3.424,0,0,0-1.5,1.856L13.5,7.181,13,7.5v-3a.5.5,0,0,0-.5-.5h-5a.5.5,0,0,0-.5.5v3l-.5-.319L6.143,6.122a3.4,3.4,0,0,0-1.5-1.856,1.929,1.929,0,0,0-1.753-.1,2.025,2.025,0,0,0-1.172,1.4L1.14,8.072a2,2,0,0,0,.45,1.772l2.1,2.372.316,2.894A1,1,0,0,0,5,16c.038,0,.072,0,.109-.006a1,1,0,0,0,.884-1.1l-.316-2.9A2,2,0,0,0,5.19,10.9L3.837,9.366l.55-2.2.213.638a2.021,2.021,0,0,0,.766,1.019l1.6,1.016A1.33,1.33,0,0,0,7.5,10h5a1.33,1.33,0,0,0,.538-.156l1.6-1.016A2.008,2.008,0,0,0,15.4,7.806l.213-.638.55,2.2L14.809,10.9a2,2,0,0,0-.488,1.094l-.316,2.9a1,1,0,0,0,.884,1.1c.037,0,.072.006.109.006a1,1,0,0,0,.994-.891l.316-2.894,2.1-2.372a2.011,2.011,0,0,0,.45-1.772ZM1.446,11.191.071,14.628a1,1,0,1,0,1.856.744l.866-2.163-.062-.569-1.284-1.45Z",
    transform: "translate(0.553 0.5)",
    fill: "none",
    stroke: "#2acbae",
    strokeWidth: 1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPeopleCarry);
export default __webpack_public_path__ + "static/media/icon-people-carry.e326fad28af0a874de3d4acbd5d8ce2f.svg";
export { ForwardRef as ReactComponent };